import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CompanyProvider } from './context/CompanyContext';
import Login from './components/Login';
import Register from './components/Register';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './components/Dashboard';
import DashboardHome from './components/DashboardHome';
import SubMastersPage from './components/SubMasters/SubMastersPage';
import BuyerLedgerCreation from './components/BuyerLedger/BuyerLedgerCreation';
import CompanyDetails from './pages/CompanyDetails';
import ClientList from './pages/ClientList';
import WRTBuyer from './pages/WRTBuyer';
import Sales from './pages/Sales';
import DMS from './pages/DMS';
import ProductMaster from './pages/Product';
import Catalog from './pages/Catalog';
import Cart from './pages/Cart';
import ClientCatalog from './pages/ClientCatalog';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard/*"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="product/master/submasters/:type" element={<SubMastersPage />} />
              <Route path="crm-master/submasters/:type" element={<SubMastersPage />} />
              <Route path="general-master/submasters/:type" element={<SubMastersPage />} />
              <Route path="crm-master/add-client" element={<BuyerLedgerCreation />} />
              <Route path="crm-master/edit-client/:id" element={<BuyerLedgerCreation />} />
              <Route path="crm-master/client-list" element={<ClientList />} />
              <Route path="general-master/wrt-buyer" element={<WRTBuyer />} />
              <Route path="product/add-product" element={<ProductMaster />} />
              <Route path="product/edit-product/:uid" element={<ProductMaster />} />
              <Route path="product/catalog" element={<Catalog />} />
              <Route path="product/cart" element={<Cart />} />
              <Route path="product/client-catalog" element={<ClientCatalog />} />
              <Route path="company-details" element={<CompanyDetails />} />
              <Route path="sales" element={<Sales />} />
              <Route path="dms" element={<DMS />} />
            </Route>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </CompanyProvider>
    </AuthProvider>
  );
}

export default App;
